import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { BlobBackground } from "@/components/ui";

// ════════════════════════════════════════════════════════════════════════════
// Home Page
// ════════════════════════════════════════════════════════════════════════════
// Landing page that redirects to dashboard if logged in, or login if not.

export default function Home() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading state while checking auth
  return (
    <div className="min-h-screen flex items-center justify-center">
      <BlobBackground />
      <div className="relative z-10 text-center">
        <div className="w-16 h-16 rounded-2xl bg-af-900 dark:bg-af-100 flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl font-bold text-white dark:text-af-900">AF</span>
        </div>
        <p className="text-af-500 animate-pulse">Loading...</p>
      </div>
    </div>
  );
}
